import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {MaterialOrderDetails} from '../types/MaterialOrderDetails';

export const useGetMaterialOrder = (materialOrderID: number) => {
    const { data, isLoading, refetch, isRefetching } = useQuery({
        queryKey: ['material-order', materialOrderID],
        queryFn: async () => await apiClient.get('material-order/details',
            {
                params: {
                    materialOrderID: materialOrderID
                }
            }) as MaterialOrderDetails
    });

    return {
        data,
        isLoading,
        refetch,
        isRefetching
    };
};
